import React, { Component, ErrorInfo, ReactNode } from 'react';
import { UnavailableStub } from './UnavailableStub';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

/** При ошибке рендера показывает заглушку (как при недоступности сервиса), без серого фона. */
export class AuthErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('AuthErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError && this.state.error) {
      return (
        <UnavailableStub
          isErrorBoundary
          message="Что-то пошло не так. Попробуйте обновить страницу."
          buttonText="Обновить страницу"
        />
      );
    }
    return this.props.children;
  }
}
